<template>
	<div v-if="!isMobile" class="container">
		<div class="body flex-grow-1 col-12 col-md-5 px-0">
			<div>
				<div class="modal-body w-full py-0 d-flex flex-column align-items-center">
					<h3 class="modal-heading">Before you go...</h3>
					<div class="modal-subheading">
						Enjoy a FREE month of Stan on us! Use this time to double-down on your Creator biz and make the most of it!
					</div>
				</div>
				<div class="d-flex flex-column  align-items-center  gap v-gap pt-1">
					<AppButton name="accept-one-free-month" size="large" @click="acceptOffer">Claim free month!</AppButton>
					<AppButton name="decline-one-free-month" size="large" class="p-1 h-auto" link @click="nextStep">No thanks</AppButton>
				</div>
			</div>
		</div>

		<div class="body flex-grow-1 col-12 col-md-5 px-0">
			<div v-if="!imageReady" class="image-placeholder" />
			<img v-show="imageReady" src="/images/cancellation/calendar.svg" @load="imageReady = true" />
		</div>
	</div>
	<div v-else class="container mobile-container d-flex justify-content-center align-items-center">
		<div class="body flex-column flex-gap-50 h-100">
			<div class="body flex-shrink-1 px-0">
				<div v-if="!imageReady" class="image-placeholder" />
				<img v-show="imageReady" src="/images/cancellation/calendar.svg" @load="imageReady = true" />
			</div>
			<div class="body px-0">
				<div>
					<div class="modal-body w-full py-0 d-flex flex-column align-items-center">
						<h3 class="modal-heading">Before you go...</h3>
						<div class="modal-subheading">
							Enjoy a FREE month of Stan on us! Use this time to double-down on your Creator biz and make the most of it!
						</div>
					</div>
					<div class="d-flex flex-column  align-items-center  gap v-gap pt-1">
						<AppButton name="accept-one-free-month" size="large" @click="acceptOffer">Claim free month!</AppButton>
						<AppButton name="decline-one-free-month" size="large" class="p-1 h-auto" link @click="nextStep">No thanks</AppButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {},
		data() {
			return {
				stepName: 'offer one free month',
				offerName: 'one free month',
				imageReady: false,
			}
		},
		computed: {
			isMobile() {
				return this.$commonHelper.isMobile()
			},
		},
		mounted() {
			this.start()
		},
		methods: {
			start() {
				this.$emit('start', {
					eventName: 'cancellation-present-offer-viewed',
					props: {
						step_name: this.stepName,
						offer_name: this.offerName,
					},
				})
			},
			acceptOffer() {
				this.$emit('free-one-month-offer-accepted', {
					eventName: 'cancellation-present-offer-accepted',
					props: {
						step_name: this.stepName,
						offer_name: this.offerName,
					},
				})
				this.close()
			},
			nextStep() {
				this.$emit('next-step', {
					eventName: 'cancellation-present-offer-ignored',
					props: {
						step_name: this.stepName,
						offer_name: this.offerName,
					},
				})
				this.close()
			},
			close() {
				this.reset()
			},
			reset() {
				this.imageReady = false
			},
		},
	}
</script>

<style lang="scss" scoped></style>
